import React, { useState } from "react";
import Button from "../Components/Common/FormElements/Button/Button";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { HeaderLogoSvg } from "../Components/Svgs";
import TextInput from "../Components/Common/FormElements/TextInput/TextInput";
import { Alert } from "react-bootstrap";
import emailValidation from "../Components/LoginForm/emailValidation";
import { forgotPassword } from "../REDUX/actions/user";

const ForgotPassword = () => {
  const { t } = useTranslation("common");
  const userData = useSelector((state) => state.userReducer);

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  const dispatch = useDispatch();

  const handleEmailChange = (e) => {
    if (!emailValidation(e.target.value) && e.target.value !== "") {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(forgotPassword(email, () => setEmail("")));
  };

  return (
    <div className="bg-blue vh100 d-flex justify-content-center align-items-center">
      <form className="loginForm bg-white br5 d-flex flex-column justify-content-center align-items-center">
        <HeaderLogoSvg
          textColor="blue"
          imageURL="poseidon-login-logo-blue.png"
        />
        <div className="mt-4 w60">
          <p className="f16 text-ultraBlack mb-2">{t("E-mail")}</p>
          <TextInput
            callback={handleEmailChange}
            autoComplete="username"
            value={email}
          />
          <div className="errorMessageContainer">
            {emailError ? (
              <span className="f12 text-red">
                {t("The email address is not valid!")}
              </span>
            ) : null}
          </div>
        </div>
        {/* <PassswordInput
        text={t("Password")}
        className="w60 loginPasswordInput"
        withoutPlaceHolder
        callback={handlePasswordChange}
      /> */}
        {/* <span
        // href="/mot-de-passe-oublie"
        // onClick={() => setresetPassword(true)}
        className="forgotPasswordLink f12 d-block w60 text-end text-blue pointer"
      >
        {t("Forgot password ?")}
      </span> */}
        {userData.error ? (
          <Alert
            variant="danger"
            className="alignH justify-content-center w60 errorAlert mt-3"
          >
            {t("Incorrect email or password!")}
          </Alert>
        ) : null}
        <Button
          loading={userData.userLoading || userData?.forgotPwdLoading}
          className="mt-3"
          onClick={handleSubmit}
          isSubmit={true}
          disabled={!email || emailError}
        >
          {t("Reset my password")}
        </Button>
      </form>
    </div>
  );
};

export default ForgotPassword;
